import defaultReducer from "./defaultReducer";

const initialState = { message: "", visible: false, onConfirm: () => {} };

export default defaultReducer("CONFIRM_INPUT_MODAL", initialState);
